import { useEffect, useState } from "react";

const DOTAZ = "(max-width: 767px)";   // stejná hranice jako `md:` v Tailwindu

/** Na telefonu se řádky tahají prstem, na počítači se klikají. */
export function useJeMobil() {
  const [mobil, setMobil] = useState(() =>
    typeof window !== "undefined" && window.matchMedia(DOTAZ).matches);
  useEffect(() => {
    const mq = window.matchMedia(DOTAZ);
    const zmena = (e) => setMobil(e.matches);
    mq.addEventListener("change", zmena);
    return () => mq.removeEventListener("change", zmena);
  }, []);
  return mobil;
}

/** Telefon i tablet (pod `lg:`) — pro široké tabulky, které se na tablet nevejdou. */
export function useJeUzky() {
  const DOTAZ_UZKY = "(max-width: 1023px)";
  const [uzky, setUzky] = useState(() =>
    typeof window !== "undefined" && window.matchMedia(DOTAZ_UZKY).matches);
  useEffect(() => {
    const mq = window.matchMedia(DOTAZ_UZKY);
    const zmena = (e) => setUzky(e.matches);
    mq.addEventListener("change", zmena);
    return () => mq.removeEventListener("change", zmena);
  }, []);
  return uzky;
}

export const omezenyPohyb = () =>
  typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
